// Core packages
import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, Router, UrlTree } from "@angular/router";

// Third party packages

// Custom packages
import {
  PUBLIC_QR_LEGACY_DATA_KEY,
  publicQrLegacyRedirectCommands,
} from "src/app/modules/public-qr-v3/public-qr-v3-legacy-redirect.utils";
import { isArchiveV3Live } from "src/app/shared/utils/archive-switch.utils";

/**
 * The stickers already printed of the archive (documents, areas, sections, the first platform's
 * areas), once the new archive is live: the legacy public page hands them to the new one
 * (@see publicQrLegacyRedirectCommands), which reads them through the legacy routes of NEW-A3.
 *
 * Switch off, nothing changes: the legacy page opens, with its calls of today. The query goes along,
 * so the names the app passes still skip the form.
 *
 * A guard and not a choice in the route table, as `ArchiveV3RedirectGuard`: the routes stay static for
 * the AOT compiler.
 *
 * @since 3.0.0
 */
@Injectable({
  providedIn: "root",
})
export class PublicQrV3LegacyGuard implements CanActivate {
  /**
   * Class constructor
   */
  constructor(private router: Router) {}

  /**
   * The new page when the new archive is live, the legacy page otherwise.
   *
   * @since 3.0.0
   */
  canActivate(route: ActivatedRouteSnapshot): boolean | UrlTree {
    const data = route && route.data ? route.data : {};
    const commands = publicQrLegacyRedirectCommands(
      this.archiveLive(),
      data[PUBLIC_QR_LEGACY_DATA_KEY],
      route ? route.params : null
    );
    if (!commands) {
      return true;
    }
    return this.router.createUrlTree(commands, { queryParams: route.queryParams });
  }

  /**
   * Whether the new archive is live; a method so that a test can turn it on.
   *
   * @since 3.0.0
   */
  protected archiveLive(): boolean {
    return isArchiveV3Live();
  }
}
